import { render, staticRenderFns } from "./MarketingSettingsForm.vue?vue&type=template&id=59aeddc0"
import script from "./MarketingSettingsForm.vue?vue&type=script&lang=js"
export * from "./MarketingSettingsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports